import {TailSpin} from "react-loader-spinner";

const Loader = () => {
    return (
        <>
            <div className="row mx-0 mt-5">
                <div className="col-auto mx-auto">
                    <TailSpin arialLabel="loading-indicator" />
                </div>
            </div>
        </>
    )
}

export default Loader;
